import React from "react";
import { Card, CardContent, CardMedia, Typography, Skeleton, useTheme } from "@mui/material";
import { Link } from "react-router-dom";

interface CardProps {
  route: string;
  image: string;
  title: string;
  text: string;
}

const linkStyle = {
  textDecoration: "none",
  color: "inherit",
};

const HomepageCard: React.FC<CardProps> = ({ route, image, title, text }) => {
  const theme = useTheme();
  return (
    <Link to={route} style={linkStyle}>
      <Card
        sx={{
          flex: 1,
          minWidth: 300,
          minHeight: 300,
          display: "flex",
          flexDirection: "column",
        }}
      >
        {image.length === 0 ? (
          <Skeleton sx={{ height: 170 }} animation={false} variant="rectangular" />
        ) : (
          <CardMedia component="img" height="170" image={image} alt="Bild" />
        )}
        <CardContent sx={{ flex: 1 }}>
          <Typography
            gutterBottom
            variant="subtitle2"
            component="div"
            color={theme.palette.primary.main}
          >
            {title}
          </Typography>
          <Typography variant="body1">{text}</Typography>
        </CardContent>
      </Card>
    </Link>
  );
};

export default HomepageCard;
